"use client";

import {
    createViewDay,
    createViewMonthAgenda,
    createViewMonthGrid,
    createViewWeek,
} from '@schedule-x/calendar';
import { createDragAndDropPlugin } from '@schedule-x/drag-and-drop';
import { createEventModalPlugin } from '@schedule-x/event-modal';
import { createEventRecurrencePlugin } from "@schedule-x/event-recurrence";
import { createEventsServicePlugin } from '@schedule-x/events-service';
import { ScheduleXCalendar, useNextCalendarApp } from '@schedule-x/react';
import { createResizePlugin } from '@schedule-x/resize';
import '@schedule-x/theme-default/dist/index.css';
import { createInteractiveEventModal, createInputField } from "@sx-premium/interactive-event-modal";
import '@sx-premium/interactive-event-modal/index.css';


import { useEffect } from 'react';
import uid2 from 'uid2';

export function CustomCalendar({ isClientView, rdvList, peopleList, attributionList, calendarFetch, calendars }) {

    const eventsService = createEventsServicePlugin();

    const activeCalendarIds = [
        { label: "Personnel", value: 'personnel' },
        { label: "Individuel", value: 'individuel' },
        { label: "Groupe", value: 'groupe' },

    ];
    // liste de clients et groupe + idclient ou  groupe
    const activeRessourceIds = attributionList || [];

    const calendarIds = calendars || [];

    const eventModal = createInteractiveEventModal({
        // dependency needed to add events
        eventsService,

        // liste des clients et groupes
        availablePeople: peopleList || [],
        // (Optional): callback for when an event is added   

        onAddEvent: async (event) => {
            const data = await calendarFetch(`${process.env.SERVER_ADRESS}/calendriers`, { event }, { method: "POST" });
            if (!data.result) {
                console.error('error', data.error);
            }
        },

        // (Optional): callback for when an event is updated
        onDeleteEvent: async (eventId) => {
            const data = await calendarFetch(`${process.env.SERVER_ADRESS}/calendriers/${eventId}`, {}, { method: "DELETE" });
            if (!data.result) {
                console.error('error', data.error);
            }
        },

        // (Optional): callback which is invoked before opening the modal. Return false to prevent the modal from opening
        canOpenModal: (event) => {
            return event.calendarId === 'personnel' || 'individuel' || 'groupe' || 'rdv';
        },

        // (Optional): configure the time picker to use 12-hour format
        has12HourTimeFormat: false,

        // (Optional): add a gray "move-bar" bar at the top of the modal, which can be used to move the modal
        movable: true,

        // (Optional): configuration for the field "title"
        fields: {
            title: {
                label: "Titre de l'évènement",
                name: 'event-title',
                validator: (value) => {
                    return {
                        isValid: !!value && value.length >= 3,
                        message: 'Le titre doit avoir au moins 3 caractères',
                    }
                }
            },
            startDate: {
                label: "Date de début",

            },
            startTime: {},
            endDate: {
                label: "Date de fin",
            },
            endTime: {},
            description: {},
            rruleFrequency: {
                label: "Fréquence"
            },
            rruleUntil: {
                label: "Jusqu'au",
            },
            people: {
                label: "Avec qui avez-vous rendez-vous ?",

            }


        },

        customFields: {

            externalMail:createInputField(
                {
                    label: 'Ou inviter une personne exterieure à Hosta (Ajouter son email)',
                    type: 'text',
                },
            ),
            calendarId:createInputField(
                { // will correspond to an event property "locationSelect"
                    label: 'Catégorie d"évènement',
                    type: 'select',
                    items: activeCalendarIds,
    
                },
            ) ,
            resourceId:createInputField(
                {
                    label: 'Afficher le rendez-vous dans le calendrier de :',
                    type: 'select',
                    items: activeRessourceIds,
    
                },

            ),
            location:createInputField(
                { // will correspond to an event property "locationSelect"
                    label: 'Lieu',
                    type: 'select',
                    items: [
                        { label: 'Visio', value: 'visio' },
                        { label: 'Présentiel', value: 'presentiel' },
                    ]
                },
            ),
            externalPresentiel:createInputField(
                {
                    label: 'Si présentiel, indiquer l\'adresse',
                    type: 'text',
                },
            ),
            calendrierGoogle:createInputField({
                label: 'Calendrier Google',
                type: 'select',
                items: calendarIds.map(({ id, name }) => ({ label: name, value: id })),

            } ),
        }

    });

   

    const plugins = [createEventRecurrencePlugin(), createDragAndDropPlugin(), createResizePlugin(), createEventModalPlugin(),eventsService, eventModal];

    

    const calendar = useNextCalendarApp({

        locale: 'fr-FR',
        dayBoundaries: {
            start: '06:00',
            end: '23:00',
          },
        views: isClientView ? [createViewMonthAgenda()] : [createViewDay(), createViewWeek(), createViewMonthGrid(), createViewMonthAgenda()],
        defaultView: isClientView ? createViewMonthAgenda().name : createViewWeek().name,
        isDark: false,
        activeCalendarIds: ['personnel', 'individuel', 'groupe', 'rdv'],
        calendars: {
            personnel: {
                colorName: 'personnel',
                lightColors: {
                    main: '#f9d71c',
                    container: '#fff5aa',
                    onContainer: '#594800',
                },
                darkColors: {
                    main: '#fff5c0',
                    onContainer: '#fff5de',
                    container: '#a29742',
                },
            },
            inviduel: {
                colorName: 'individuel',
                lightColors: {
                    main: '#f91c45',
                    container: '#ffd2dc',
                    onContainer: '#59000d',
                },
                darkColors: {
                    main: '#ffc0cc',
                    onContainer: '#ffdee6',
                    container: '#a24258',
                },
            },
            groupe: {
                colorName: 'groupe',
                lightColors: {
                    main: '#1cf9b0',
                    container: '#dafff0',
                    onContainer: '#004d3d',
                },
                darkColors: {
                    main: '#c0fff5',
                    onContainer: '#e6fff5',
                    container: '#42a297',
                },
            },
            rdv: {
                colorName: 'rdv',
                lightColors: {
                    main: '#1c7df9',
                    container: '#d2e7ff',
                    onContainer: '#002859',
                },
                darkColors: {
                    main: '#c0dfff',
                    onContainer: '#dee6ff',
                    container: '#426aa2',
                },
            },
        },


        callbacks: {
            onDoubleClickDateTime(dateTime) {
                eventModal.clickToCreate(dateTime, {
                    id: uid2(10),
                })
            },

            async onEventUpdate(updatedEvent) {
                const { id } = updatedEvent;

                const data = await calendarFetch(`${process.env.SERVER_ADRESS}/calendriers/${id}`, { event: updatedEvent }, { method: "PUT" });
                if (!data.result) {
                    console.error('error', data.error);
                }
            },
        },

        events: rdvList,

    },
        plugins
    );


    // Load rdvList into eventsService when calendar and rdvList are available
    useEffect(() => {
        if (calendar && rdvList.length > 0) {
            calendar.eventsService.set(rdvList);
        }
    }, [rdvList]);


    return (
        <ScheduleXCalendar calendarApp={calendar} />
    );
}

